import { gql } from "@apollo/client";

export const GET_CF_ROLES = gql`
  query CfRoles {
    cfRoles {
      status
      msg
      total
      dataMany {
        id
        name
        note
        permissions
        createdAt
      }
    }
  }
`;

export const GET_SHOP_STAFFS = gql`
  query ShopStaffs($where: ShopStaffWhereInput, $skip: Int, $limit: Int) {
    shopStaffs(where: $where, skip: $skip, limit: $limit) {
      status
      msg
      dataMany {
        total
        data {
          id
          username
          firstName
          lastName
          nickname
          phone
          gender
          role
          platform
          isDeleted
          createdAt
          permission {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_MY_PERMISSION = gql`
  query MyPermission($where: UserWhereInputOne!) {
    user(where: $where) {
      id
      role
      platform
      permission {
        id
        name
        permissions
        platform
      }
    }
  }
`;
